import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { OrderBuilderState } from '@ordersnproducts/modules/order-builder/reducers';
import { ConfigurableFormComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/containers/configurable-form/configurable-form.component';
import { FieldConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/models/field-configs/field-config.interface';
import { OnFieldChanged } from '@ordersnproducts/modules/shared/modules/configurable-form/models/on-field-changed';
import { ChangeUnloadTimeAction } from '../../../rms-specification/actions/single-catalogs.actions';
import { getUnloadTimes } from '../../../rms-specification/selectors/single-catalogs';
import { filter, take } from 'rxjs/operators';
import { ImUnloadTime } from '@cemex-core/cmx-api';
import { SpecFieldNames } from '../../constants/specification-field-names.enum';

@Injectable()
export class SetUnloadTimeChangeCommand implements OnFieldChanged {
  constructor(private store: Store<OrderBuilderState>) {}
  onFieldChanged(value: any, formGroup: UntypedFormGroup, form: ConfigurableFormComponent, config?: FieldConfig): void {
    if (value) {
      this.store
        .select(getUnloadTimes)
        .pipe(filter((data) => data.length > 0))
        .pipe(take(1))
        .subscribe((unloadTimes: ImUnloadTime[]) => {
          const unloadTime = unloadTimes.find((time) => time.unloadTimeCode === value);
          if (!!unloadTime) {
            const unloadTimeMinutes = unloadTime['unloadTimeMinutes'];
            const spacingControl = formGroup.get(SpecFieldNames.SPACING);
            const spacingValue = spacingControl.value;
            if (spacingValue && spacingValue < unloadTimeMinutes) {
              spacingControl.setValue(unloadTimeMinutes);
            }
            this.store.dispatch(new ChangeUnloadTimeAction(unloadTimeMinutes));
          }
        });
    } else {
      this.store.dispatch(new ChangeUnloadTimeAction(null));
    }
  }
}
